import type { Reading, ReadingMetrics } from "./types";

const WORD_PATTERN = /\p{L}+(?:[’'-]\p{L}+)*/gu;

function countWords(text: string) {
  return text.match(WORD_PATTERN)?.length || 0;
}

export function computeReadingMetrics(reading: Pick<Reading, "segments" | "words">): ReadingMetrics {
  const wordCount = reading.segments.reduce((total, segment) => total + countWords(segment.text), 0);
  const dialogueWords = reading.segments
    .filter((segment) => segment.kind === "dialogue")
    .reduce((total, segment) => total + countWords(segment.text), 0);
  const taughtWords = Object.keys(reading.words).length;
  const uninterruptedMinutes = Math.max(1, Math.ceil(wordCount / 210));
  const explorationMinutes = taughtWords
    ? Math.min(Math.ceil(taughtWords * 0.75), Math.ceil(uninterruptedMinutes * 0.35 + 1))
    : 0;

  return {
    wordCount,
    estimatedMinutes: uninterruptedMinutes + explorationMinutes,
    uninterruptedMinutes,
    explorationMinutes,
    dialogueRatio: wordCount ? Number((dialogueWords / wordCount).toFixed(3)) : 0,
    taughtWordDensity: wordCount ? Number(((taughtWords / wordCount) * 100).toFixed(3)) : 0,
  };
}
